import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { CustomerProfilePage } from './page';

@Component({
  selector: 'app-page-customerProfile',
  template: '<div class="react-page" #container></div>'
})
export class PageCustomerProfileComponent extends ReactPageComponent {
  get Component(){
    return CustomerProfilePage;
  }
}
